export default __webpack_public_path__ + "static/media/17.72a80244.jpg";